import './browser';


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/index.tsx